<template>
  <Hint v-if="intent && intent.ratio">
    <p>
      「{{ keyword }}」の検索結果から、このキーワードの検索意図は<Label
        variant="intent"
        :class="'is-' + intent.name"
        >{{ intent.label }}</Label
      >のクエリが上位の{{
        intent.ratio | percentage | roundFloatingPointNumber(1)
      }}%を占めています。
    </p>
  </Hint>
</template>

<script>
import { INTENT_TYPES } from '@/constants';
import Hint from '@/components/Hint';
import Label from '@/components/Label';

export default {
  props: {
    keyword: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  components: {
    Hint,
    Label
  },
  computed: {
    intents() {
      // 1～10位のインテントの配列
      return this.items
        .filter(item => item.rank >= 1 && item.rank <= 10)
        .map(item => item.intent && item.intent.label);
    },
    intent() {
      const keys = Object.keys(INTENT_TYPES);
      const total = this.intents.length;
      const max = keys
        .map(key => {
          const count = this.intents.filter(intent => intent && intent === key)
            .length;

          return {
            count: count,
            label: INTENT_TYPES[key].label,
            name: INTENT_TYPES[key].name
          };
        })
        .reduce((a, b) => {
          return a.count >= b.count ? a : b;
        });

      return {
        label: max.label,
        name: max.name,
        ratio: max.count / total
      };
    }
  }
};
</script>
